class MobileNavToggle extends HTMLElement {
	constructor() {
		super();
		this.menuDrawer = document.querySelector('.f-drawer-mobile-nav');
		this.openNavBound = this.openNav.bind(this);
		this.addEventListener('click', this.openNavBound);

		if (this.menuDrawer) {
			this.menuDrawer.addEventListener('close', () => {
				this.setAttribute('aria-expanded', 'false');
			});
		}
	}

	disconnectedCallback() {
		this.removeEventListener('click', this.openNavBound);
	}

	openNav() {
		if (this.menuDrawer) {
			this.menuDrawer.openDrawer();
			this.setAttribute('aria-expanded', 'true');
		}
	}
}
customElements.define('mobile-nav-toggle', MobileNavToggle);